import { render, staticRenderFns } from "./BarcodeOrderDelivering.vue?vue&type=template&id=3bf84e34"
import script from "./BarcodeOrderDelivering.vue?vue&type=script&lang=ts"
export * from "./BarcodeOrderDelivering.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports